<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_19_134)">
      <path d="M30 60C13.5 60 0 46.5 0 30C0 13.5 13.5 0 30 0C46.5 0 60 13.5 60 30C60 46.5 46.5 60 30 60ZM30 2.1C14.6 2.1 2.1 14.6 2.1 30C2.1 45.4 14.6 57.9 30 57.9C45.4 57.9 57.9 45.4 57.9 30C57.9 14.6 45.4 2.1 30 2.1Z" fill="#ffffff"/>
      <path d="M12.6 21.0999C14.2 21.0999 17.7 21.0999 18.9 21.0999C19.1 21.0999 19.4 21.1999 19.5 21.4999C20.9 24.5999 22.7 27.4999 24.8 29.9999C25 30.2999 25.4 30.2999 25.6 29.8999C26.3 28.2999 27.5 24.3999 25.1 21.5999C24.9 21.3999 25 20.9999 25.3 20.7999C27.7 19.7999 30 19.6999 32.3 20.6999C32.8 20.8999 33.1 21.3999 33.1 21.8999L33.6 29.9999C33.6 30.3999 33.9 30.5999 34.3 30.5999C36.9 29.9999 38.5 26.0999 40 21.9999C40.2 21.4999 40.7 21.1999 41.2 21.1999H47C47.5 21.1999 47.9 21.5999 47.8 22.0999C47.3 24.9999 44.3 28.7999 42.8 30.5999C42.3 31.1999 42.3 32.0999 42.8 32.7999L48 38.9999C48.4 39.3999 48.1 40.0999 47.5 40.0999H40.9C40.4 40.0999 39.8 39.8999 39.5 39.4999L34.9 35.6999C34.7 35.3999 34.2 35.2999 34 35.5999C33.4 36.2999 33.5 37.0999 33.2 39.0999C33.1 39.6999 32.6 40.0999 32 40.0999H27.5C26.9 40.0999 26.2 39.9999 25.7 39.6999C23 38.3999 15.9 33.9999 12 21.8999C11.9 21.4999 12.2 21.0999 12.6 21.0999Z" fill="#ffffff"/>
    </g>
    <defs>
      <clipPath id="clip0_19_134">
        <rect width="60" height="60" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>

</script>

<style scoped>

</style>
